export enum RoutePath {
    ACCESS = 'acceso',
    ADD = 'alta',
    INCREASE_HOARD = 'ampliar',
    INICIO = 'inicio',
    ADMIN = '/admin',
    BRANCHES = 'sucursales',
    BUDGETS = 'presupuestos',
    CANCEL_ITEMS = 'cancelar-productos',
    CASH_FUNDS = 'cajas',
    CATEGORIES = 'categorias',
    CHECKS = 'cheques',
    COMPANY = 'compania',
    COMPLETE_DELIVERY = 'completar-entrega',
    CONFIRM_PAYMENT = 'confirmar-pago',
    CREATE = 'crear',
    CREATE_HOARD = 'crear-acopio',
    CREATE_SALE = 'crear-venta',
    CREDIT_ACCOUNTS = 'cuentas-corrientes',
    CREDIT_CARDS = 'tarjetas',
    CREDIT_PAYMENTS = 'cobros',
    CUSTOMER_TYPES = 'listas-de-precios',
    CUSTOMERS = 'clientes',
    DEBTS = 'deudas',
    DELIVERY_NOTES = 'remitos',
    DRIVERS = 'conductores',
    EDIT = 'editar',
    EDIT_DELIVERY_DATA = 'editar-datos-de-entrega',
    EMIT_DELIVERY = 'emitir-entrega',
    EMPLOYEES = 'empleados',
    ERROR = '/error',
    EXPENSE_SUPPLIERS = 'proveedores-de-gasto',
    EXPENSE_TYPES = 'tipos-de-gasto',
    EXPENSES = 'gastos',
    GENERATE_DELIVERY_NOTE = 'generar-remito',
    HOARDS = 'acopios',
    IMPORT = 'importar',
    IMPORT_DATA = 'importar-datos',
    MANUAL_CREDIT_NOTE = 'nota-de-credito',
    INVOICE = 'invoice',
    INVOICES = 'invoices',
    PAYMENT_ORDERS = 'pagos',
    PAYMENT_TYPES = 'medios-de-pago',
    PENDING_PAYMENTS = 'pagos-pendientes',
    PICKUP_ORDERS = 'ordenes-de-retiro',
    PREPARE_TRUCK = 'preparar-camion',
    PRICES = 'precios',
    PRODUCTS = 'productos',
    PURCHASES = 'compras',
    RECEPTION_ORDERS = 'ordenes-de-recepcion',
    REGISTER_RETURN = 'registrar-devolucion',
    REQUESTS = 'solicitudes',
    ROADMAPS = 'hojas-de-ruta',
    SALARIES = 'salarios',
    SALES = 'ventas',
    SETTINGS = 'configuracion',
    SHIPMENT_ORDERS = 'ordenes-de-envio',
    SHIPMENT_PREPARATION = 'preparacion-de-envios',
    STOCK = 'stock',
    SUPPLIERS = 'proveedores',
    SUBSTRACT = 'baja',
    TAXES = 'impuestos',
    TICKETS = 'facturas',
    TRANSACTIONS = 'transacciones',
    TRANSFER = 'transferir',
    TRANSFORM = 'transformar',
    UPDATE = 'actualizar',
    USER = 'usuario',
    VEHICLES = 'vehiculos'
}
